module.exports = __webpack_public_path__ + "f2021991f68da1fdf1a591a672a69ee4.svg";